module.exports = __webpack_public_path__ + "static/img/T240320_1.97761b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T240320_1.png
// module id = RKNo
// module chunks = 41